module.exports = __webpack_public_path__ + "img/home-happy-1.8cc41dc1.png";